import { GetLicenseSystemAccessByUserIdPayload } from 'src/graphql/generated/types';

export const roles = ['Operator', 'Viewer'] as const;
export type CPGORole = typeof roles[number];

const OPERATOR_ROLE: CPGORole = 'Operator';
export const DEFAULT_ROLE_SELECTION = {
    value: OPERATOR_ROLE,
    label: OPERATOR_ROLE,
};
export interface LicenseSystemAccessViewModel {
    licenseSystemId: string;
    role: CPGORole;
}

export const mapLicenseSystemAccessPayloadToViewModel = (source: GetLicenseSystemAccessByUserIdPayload): Array<LicenseSystemAccessViewModel> => {

    return (source.licenseSystemAccessItems || []).map((licenseSystemAccess) => ({
        licenseSystemId: licenseSystemAccess.licenseSystemId,
        role: licenseSystemAccess.role,
    }));
};